import React from 'react';
import { Outlet } from 'react-router-dom';

const VehicleList = () => {
  return <Outlet />;
};

export default VehicleList;
